// src/lib/fetcher.js

/**
 * A standard fetcher to get data from API using SWR.
 * Throws an error, when HTTP-requests are not successful.
 *
 * @param {string} url - API url.
 * @returns {Promise<any>} - JSON answer from API endpoint
 */
export const fetcher = async (url) => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Fehler beim Laden von Daten: ${response.statusText}`);
  }

  return response.json();
};